import * as Scrivito from "scrivito"
import { useHelmet } from "shared/lib/useHelmet"

const defaultLang = "de"

export function useScrivitoPage() {
  const page = Scrivito.currentPage()

  useHelmet({
    title: page?.get("title")?.toString() || "",
    htmlAttributes: {
      lang: page?.language() || defaultLang
    },
    meta: [
      {
        name: "description",
        content: page?.get("description")?.toString() || ""
      },
      {
        name: "keywords",
        content:
          ((page?.get("keywords") as string[])?.join(", ") as string) ?? ""
      }
    ],
    link: page
      ? [
          {
            rel: "canonical",
            href: Scrivito.urlFor(page),
            type: "text/html"
          }
        ]
      : []
  })
}
